import { canSplitStatus } from "@redotech/redo-fulfillment-common/fulfillment-group-status";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { groupFulfillmentOrderLineItems } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { memo, useContext, useMemo } from "react";
import { ItemsTable } from "../../common/items-table";
import { SplitGroupButton } from "../../common/split-group-button";
import { useFulfillmentGroupPermissions } from "../../utils/use-assigned-fulfillment-service";

export const FulfillmentItemsCard = memo(function FulfillmentItemsCard({
  fulfillmentGroups,
  setRows,
}: {
  fulfillmentGroups: readonly FulfillmentGroupData[];
  setRows?: (value: React.SetStateAction<FulfillmentGroupData[]>) => void;
}) {
  const team = useContext(TeamContext);
  const lineItems = useMemo(() => {
    return groupFulfillmentOrderLineItems(
      fulfillmentGroups.flatMap((group) => group.items),
      {
        degroupByCustomAttributes:
          team?.settings.outboundLabels?.degroupItemsByCustomAttributes,
      },
    );
  }, [
    fulfillmentGroups,
    team?.settings.outboundLabels?.degroupItemsByCustomAttributes,
  ]);

  return <ItemsTable items={lineItems} showBin team={team} />;
});

export const FulfillmentItemsCardHeaderActions = memo(
  function FulfillmentItemsCardHeaderActions({
    fulfillmentGroups,
    setRows,
  }: {
    fulfillmentGroups: readonly FulfillmentGroupData[];
    setRows?: (value: React.SetStateAction<FulfillmentGroupData[]>) => void;
  }) {
    const { permissionsToEditEveryGroup } =
      useFulfillmentGroupPermissions(fulfillmentGroups);

    const lineItems = useMemo(() => {
      return groupFulfillmentOrderLineItems(
        fulfillmentGroups.flatMap((group) => group.items),
        { degroupByCustomAttributes: false },
      );
    }, [fulfillmentGroups]);

    const lineItemsQuantity = useMemo(() => {
      return lineItems.reduce((acc, item) => acc + item.quantity, 0);
    }, [lineItems]);

    const canSplit = useMemo(() => {
      return (
        fulfillmentGroups.length === 1 &&
        lineItemsQuantity > 1 &&
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        canSplitStatus(fulfillmentGroups[0].status)
      );
    }, [fulfillmentGroups, lineItemsQuantity]);

    if (!canSplit) {
      return null;
    }

    return (
      <SplitGroupButton
        disabled={!permissionsToEditEveryGroup}
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        fulfillmentGroup={fulfillmentGroups[0]}
        isSlideout
        setRows={setRows}
        size="sm"
        triggerReload={async () => {}}
      />
    );
  },
);
